webpackJsonp([31],{

/***/ 1279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LandersNewHomesModel; });
var LandersNewHomesModel = function LandersNewHomesModel(defaultParams) {
  this.data = defaultParams;

  this.getData = function () {
    return this.data;
  };
};



/***/ }),

/***/ 129:
/***/ (function(module, exports) {

MOVE.HeroImages = function (MOVE) {
  "use strict";

  var init = function init(options) {
    var heroImages = $(options.target);
    // owl carousel
    heroImages.owlCarousel({
      lazyLoad: options.lazyLoad,
      items: 1,
      loop: true,
      autoplay: true,
      autoplayTimeout: 11000,
      animateOut: options.effect
    }); // /owlCarousel
  }; // /init closing brackets

  MOVE.HeroImages = {
    init: init
  };

  return MOVE.HeroImages;
}(MOVE || {});

/***/ }),

/***/ 1449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_landers_newhomesandconstruction__ = __webpack_require__(1279);


(function (LANDERS_NEWHOMES) {

  var init = function init() {
    LANDERS_NEWHOMES.model = new __WEBPACK_IMPORTED_MODULE_0__models_landers_newhomesandconstruction__["a" /* LandersNewHomesModel */](defaultCriteriaOptions());
  };

  var defaultCriteriaOptions = function defaultCriteriaOptions() {
    return {
      location: MOVE.SearchHelper.getRecentSearchedLocation(MOVE.CONSTANTS.DEFAULT_LANDING_PAGE_LOCATION),
      property_status: MOVE.CONSTANTS.PROPERTY_STATUS.forSale
    };
  };

  LANDERS_NEWHOMES.LandingPage = {
    init: init
  };
})(MOVE.LANDERS_NEWHOMES);
MOVE.LANDERS_NEWHOMES.LandingPage.init();

/***/ }),

/***/ 1450:
/***/ (function(module, exports) {

MOVE.LANDERS_NEWHOMES = function (MOVE) {
  var init = function init() {};

  MOVE.LANDERS_NEWHOMES = {
    init: init
  };

  return MOVE.LANDERS_NEWHOMES;
}(MOVE || {});

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

MOVE.HOMEPAGE = function (MOVE) {
  var init = function init() {};

  MOVE.HOMEPAGE = {
    init: init
  };

  return MOVE.HOMEPAGE;
}(MOVE || {});

/***/ }),

/***/ 1645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__application_critical__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_critical_hero_images__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_critical_hero_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_critical_hero_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_homepage_homepage__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_homepage_homepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_homepage_homepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_landers_newhomesandconstruction_landers_newhomesandconstruction__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_landers_newhomesandconstruction_landers_newhomesandconstruction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_landers_newhomesandconstruction_landers_newhomesandconstruction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_landers_newhomesandconstruction_models_landers_newhomesandconstruction__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_landers_newhomesandconstruction_controllers_landers_newhomesandconstruction__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_app__);








/***/ }),

/***/ 19:
/***/ (function(module, exports) {

(function () {

    //bootstrap application
    MOVE.init();
})();

/***/ })

},[1645]);


// WEBPACK FOOTER //
// landers_newhomesandconstruction_critical-d2e2c03b06adbcfc7a25.js